import {
  IconNameEnum,
  useFlightStyles,
  useModuleBEM,
} from "@b2bportal/core-themes";
import {
  CoreFlightsComponent,
  type PlatformComponentProps,
} from "@b2bportal/core-types";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogTrigger,
  Icon,
} from "@b2bportal/core-ui";
import { useI18nContext } from "@hopper-b2b/i18n";
import clsx from "clsx";
import defaultStyles from "./FareCombinationBanner.module.scss";

export interface FareCombinationBannerProps extends PlatformComponentProps {
  className?: string;
}

export const FareCombinationBanner = ({
  className,
}: FareCombinationBannerProps) => {
  const styles = useFlightStyles(
    CoreFlightsComponent.FareCombinationBanner,
    defaultStyles
  );

  const [block, cn] = useModuleBEM(
    styles,
    CoreFlightsComponent.FareCombinationBanner
  );

  const { t } = useI18nContext();

  return (
    <div className={clsx(block, className)}>
      <div className={cn("flight-combination-content")}>
        <Icon
          className={cn("flight-combination-icon")}
          iconName={IconNameEnum.info}
        />
        <div className={cn("flight-combination-copy")}>
          {t("combinationFlightWarning")}
        </div>
      </div>
      <Dialog>
        <DialogTrigger className={cn("flight-combination-cta")}>
          {t("learnMore")}
        </DialogTrigger>
        <DialogContent
          className={cn("flight-combination-dialog")}
          title={t("combinationFlightTitle")}
        >
          <div className={cn("flight-combination-description", ["first-line"])}>
            {t("combinationFlightDescription")}
          </div>
          <div className={cn("flight-combination-description")}>
            {t("combinationFlightTooltip")}
          </div>
          <DialogClose className={cn("flight-combination-close-button")}>
            {t("close.button")}
          </DialogClose>
        </DialogContent>
      </Dialog>
    </div>
  );
};
